// extracted by mini-css-extract-plugin
module.exports = {"sidebarHamburger":"_19Jxg","showHamburger":"qv9zT","sidebarMenuTitle":"_3VQoM"};